import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import dayjs from 'src/libs/dayjs';

import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.Discussion>({
  selectId: (model) => model.id,
  sortComparer: (a, b) => {
    return dayjs(a.created_at).isBefore(b.created_at) ? -1 : 1;
  },
});

const { reducer, actions } = createSlice({
  name: 'discussion_reply',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.Discussion[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.Discussion>) {
      adapter.removeOne(state, 'placeholder');
      adapter.upsertOne(state, action);
    },
    updateError(state, action: PayloadAction<Model.Discussion>) {
      adapter.updateOne(state, {
        id: action.payload?.id || 'placeholder',
        changes: {
          error: true,
          message: action.payload?.message,
        },
      });
    },
    removeEntity(state, action: PayloadAction<Model.Discussion>) {
      adapter.removeOne(state, action.payload.id);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    createDummyReply(state, action: PayloadAction<Partial<Model.Discussion>>) {
      const reply = {
        ...action.payload,
        id: 'placeholder',
      } as Model.Discussion;

      adapter.upsertOne(state, reply);
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.discussionReply,
);

export const selectDiscussionByContentId = createSelector(
  selector.selectAll,
  (state: RootState, class_topic_content_id?: string) => class_topic_content_id,
  (discussion, class_topic_content_id) => {
    return discussion.filter(
      (d) => d.class_topic_content_id === class_topic_content_id,
    );
  },
);

export { reducer };
export default actions;
